<template>
  <div class="address_container addressMb">
    <div class="top-card-container">
      <div class="top-card first" v-if="!this.defaultAddress.Street">
        <div class="top-card-title">
          <p>{{ $t('no_address_found') }}</p>
          <span>{{ $t('default') }}</span>
        </div>
        <div class="top-card-info">{{ $t('add_new_address') }}</div>
      </div>
      <div class="top-card" v-if="this.defaultAddress.Street">
        <div class="top-card-title">
          <p>{{ this.defaultAddress.FirstName }}</p>
          <span>{{ $t('default') }}</span>
        </div>
        <div class="top-card-body">
          <div class="top-card-info">
            <p>{{ this.defaultAddress.FirstName }} {{ this.defaultAddress.LastName }}</p>
            <p>{{ this.defaultAddress.Street }}, {{ this.defaultAddress.City }}, {{ this.defaultAddress.State }}
              {{ this.defaultAddress.Zip }}</p>
            <p>{{ this.defaultAddress.Telephone }}</p>
          </div>
          <div class="top-card-check">
            <i class="fa fa-check" aria-hidden="true"></i>
          </div>
        </div>
        <div class="top-card-change">
          <p><!--占位用--></p>
          <p @click="openConfirmationDeleteAlert(defaultAddress.CustomerDetail_id, getDefaultAddress)">{{ $t('delete') }}</p>
        </div>
      </div>
    </div>
    <div class="top-card-container"
         v-for="item in notDefaultAddressList"
         :key="item.CustomerDetail_id">
      <div class="top-card">
        <div class="top-card-title">
          <p>{{ item.FirstName }}</p>
          <span v-if="item.IsDefault">{{ $t('default') }}</span>
        </div>
        <div class="top-card-body">
          <div class="top-card-info">
            <p>{{ item.FirstName }} {{ item.LastName }}</p>
            <p>{{ item.Street }}, {{ item.City }}, {{ item.State }}
              {{ item.Zip }}</p>
            <p>{{ item.Telephone }}</p>
          </div>
          <div class="top-card-check" v-if="item.IsDefault">
            <i class="fa fa-check" aria-hidden="true"></i>
          </div>
        </div>
        <div class="top-card-change">
          <p @click="changeDefaultAddress(item.CustomerDetail_id)">{{ $t('set_as_default') }}</p>
          <p @click="openConfirmationDeleteAlert(item.CustomerDetail_id)">{{ $t('delete') }}</p>
        </div>
      </div>
    </div>

    <div class="address-body-container">
      <div v-if="!showAddAddress" class="address-add-container">
        <img src="../../assets/img/address-add.jpg" @click="showAddAddress = true" alt="">
      </div>
      <div v-if="showAddAddress" class="address-form-container">
        <div class="address-line">
        </div>
        <div class="address-form-title">
          {{ $t('addNewAddress') }}
        </div>
        <div class="input-item">
          <p class="input-title">{{ $t('name') }}</p>
          <input v-model="addressForm.Name"
                 :placeholder="[(formHasErrors && !addressForm.Name) ? $t('name_required') : $t('name')]"
                 :class="[(formHasErrors && !addressForm.Name) ? 'input-box-error' : 'input-box']"/>
        </div>
        <div class="input-item">
          <p class="input-title">{{ $t('phone') }}</p>
          <input v-model="addressForm.Telephone"
                 :placeholder="[(formHasErrors && !addressForm.Telephone) ? $t('phone_required') : $t('phone')]"
                 :class="[(formHasErrors && !addressForm.Telephone) ? 'input-box-error' : 'input-box']"/>
        </div>
        <div class="input-item">
          <p class="input-title">{{ $t('address') }}</p>
          <input v-model="addressForm.Street"
                 :placeholder="[(formHasErrors && !addressForm.Street) ? $t('address_required') : $t('enter_delivery_address')]"
                 :class="[(formHasErrors && !addressForm.Street) ? 'input-box-error' : 'input-box']"/>
        </div>
        <div class="input-item-dual">
          <div class="input-itemcity">
            <p class="input-title">{{ $t('city') }}</p>
            <input v-model="addressForm.City"
                   :placeholder="[(formHasErrors && !addressForm.City) ? $t('city_required') : $t('city')]"
                   :class="[(formHasErrors && !addressForm.City) ? 'input-box-error' : 'input-box']"/>
          </div>
          <div class="input-itemzip">
            <p class="input-title">{{ $t('zipCode') }}</p>
            <input v-model="addressForm.Zip"
                   :placeholder="[(formHasErrors && !addressForm.Zip) ? $('zip_required') : $t('zipCode')]"
                   :class="[(formHasErrors && !addressForm.Zip) ? 'input-box-error' : 'input-box']"/>
          </div>
        </div>
        <div class="input-item">
          <p class="input-title">{{ $t('customer_note') }}</p>
          <input class="input-box" :placeholder="$t('customer_note')" v-model="addressForm.Note"/>
        </div>

        <div class="address-submit-container">
          <el-checkbox v-model="addressForm.IsDefault" :disabled="addresses.length < 1">
            {{ $t('save_as_default') }}
          </el-checkbox>
          <button class="address-submit-button" @click="onSubmit($event, addressForm)">{{ $t('save') }}</button>
        </div>

      </div>
    </div>


    <transition name="modal" v-if="selectDefaultModalVisibility">
      <div class="modal-mask" @click="selectDefaultModalVisibility=false">
        <div class="modal-wrapper">
          <div class="modal-container6" @click.stop>
            <p class="address-select-title">{{ $t('select_a_default') }}</p>
            <div class="address-select-body" v-show="this.addresses.length > 0">
              <el-select
                class="element-select"
                v-model="defaultAddressSelectedId"
                @change="changeDefaultAddress"
                popper-class="address-select-el-component"
                placeholder="Select an Address">
                <el-option
                  v-for="item in addresses"
                  :key="item.CustomerDetail_id"
                  :label="item.Street + ', ' + item.City + ', ' + item.State + ' ' + item.Zip"
                  :value="item.CustomerDetail_id"
                >
                  <div class="address-option-container">
                    <span>{{ item.Street + ', ' + item.City + ', ' + item.State + ' ' + item.Zip }}</span>
                    <i class="el-icon-delete" @click.stop="openConfirmationDeleteAlert(item.CustomerDetail_id)"></i>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="address-button-container">
              <button class="address-button" @click="setDefaultAddress">{{ $t('confirm') }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import {
  mapState,
  mapActions,
} from 'vuex'

import {deleteAddress} from "../../mixin";

export default {
  name: 'account-address',
  mixins: [deleteAddress],
  data() {
    return {
      selectDefaultModalVisibility: false,
      defaultAddressSelectedId: null,
      defaultAddressSelectedData: null,

      showAddAddress: false,
      formHasErrors: false,

      dialogVisible: false,
      errorSubmitting: false,
      submitting: false,
      addressForm: {
        FirstName: '', //名字
        LastName: '', //名字
        Street: '', //地址
        // apartment: '', //地址
        City: '', //城市
        Zip: '', //编码
        Telephone: '', //联系方式
        Country: 'United States', //国家
        // State: 'CA', //地区
        State: '', //地区
        IsDefault: true,
      },
      CountryList: [{
        value: '',
        label: '---'
      }, {
        value: 'United States',
        label: 'United States'
      }],
      stateOptions: this.$store.state.addresses.states,
    }
  },
  activated() {
    this.showAddAddress = false;
    this.resetForm();
  },
  methods: {
    ...mapActions('addresses', ['fetchAddresses', 'postAddress', 'editAddress']),
    resetForm() {
      this.addressForm = {
        FirstName: '', //名字
        LastName: '', //名字
        Street: '', //地址
        City: '', //城市
        Zip: '', //编码
        Telephone: '', //联系方式
        Country: 'United States', //国家
        State: '', //地区
        IsDefault: true,
      }
    },
    openAlert() {
      this.$alert('You have successfully added a new address', 'Success', {
        confirmButtonText: 'OK',
        type: 'success',
        center: true
      }).then(() => {
        this.dialogVisible = false;
      }).catch(() => {
      });
    },
    openEditSuccessAlert() {
      this.$alert('An address has been modified', 'Success', {
        confirmButtonText: 'OK',
        type: 'success',
        center: true
      }).then(() => {
        this.dialogVisible = false;
      }).catch(() => {
      });
    },
    handleClose(event) {
      event.preventDefault();
      this.dialogVisible = false;
    },
    validPhoneNumber: function (phone) {
      // const phoneNumberRegEx = /^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-/\s.]?[0-9]{4}$/;
      const phoneNumberRegEx = /^\d{10}$/;
      return phoneNumberRegEx.test(phone);
    },
    checkForm(form) {
      console.log("checkForm", form);
      const validPhoneNumber = this.validPhoneNumber
      if (!form.Name || !form.Street || !form.Zip || !form.City || !form.Telephone) {
        this.formHasErrors = true;
        return false;
      }
      if (!validPhoneNumber(form.Telephone)) {
        this.formHasErrors = true;
        return false;
      }
      return true;
    },
    onSubmit(event, form) {
      if (this.submitting) {
        return;
      }
      if (!this.checkForm(form)) {
        return;
      }
      form.FirstName = form.Name.split(' ', 1)[0];
      form.LastName = form.Name.substr(form.Name.indexOf(" ") + 1);
      event.preventDefault();
//    this.$refs['addressForm'].validate((valid) => {
//     if (!valid) {
//      return;
//     } else {
      const address = {
        ...form,
      };
      this.submitting = true;
      if (address.CustomerDetail_id) {
        this.editAddress([address, address.CustomerDetail_id])
          .then(res => {
            this.openEditSuccessAlert();
            this.fetchAddresses();
            this.submitting = false;
          })
          .catch(err => {
            alerrt(err)
          })
      } else {
        this.postAddress(address)
          .then((res) => {
            this.openAlert();
            this.resetForm();
            this.submitting = false;
            // this.$refs['addressForm'].clearValidate();
            this.fetchAddresses();
            this.getDefaultAddress()
            this.showAddAddress = false;
            this.formHasErrors = false;
          })
          .catch(err => {
            alert(err);
          })
      }
//     }
//    });
    },
    editAddressModalOpen(address) {
      const newAddress = {
        ...address,
      }
      this.addressForm = newAddress;
      this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
      this.dialogVisible = true;
    },
    newAddressAdd() {
      this.resetForm();
      this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
      this.dialogVisible = true;
    },


    setDefaultAddress() {
      console.log("setDefaultAddress", this.defaultAddressSelectedData);
      this.defaultAddressSelectedData.IsDefault = true;
      this.editAddress([this.defaultAddressSelectedData, this.defaultAddressSelectedData.CustomerDetail_id])
        .then(res => {
          this.fetchAddresses();
          this.getDefaultAddress()
          this.selectDefaultModalVisibility = false;
          this.defaultAddressSelectedData = null;
        })
        .catch(err => {
          // console.log("err", err);
        })
    },
    changeDefaultAddress(id) {
      this.defaultAddressSelectedData = this.addresses.find(address => address.CustomerDetail_id === id)
      this.setDefaultAddress()
    },
    getDefaultAddress() {
      this.$store.dispatch('addresses/fetchDefaultAddress');
    }
  },
  mounted() {
    this.fetchAddresses();
    this.getDefaultAddress()
  },
  watch: {
    addresses: function (newVal, oldVal) {
      //   console.log("addresses", newVal);
      if (newVal.length < 1) {
        this.addressForm.IsDefault = true;
      }
    },
    defaultAddress: function (newVal, oldVal) {
      this.defaultAddressSelectedId = newVal.CustomerDetail_id;
      this.defaultAddressSelectedData = newVal;
    },
  },
  computed: {
    ...mapState({
      addresses: state => state.addresses.customerDetails,
      defaultAddress: state => state.addresses.defaultAddress,
      rules() {
        return {
          FirstName: [{
            required: true,
            message: this.$t('firstNameRequired'),
            trigger: 'blur'
          },
            {
              min: 2,
              max: 20,
              message: this.$t('firstNameLengthRequired'),
              trigger: 'blur'
            }
          ],
          LastName: [{
            required: true,
            message: this.$t('lastNameRequired'),
            trigger: 'blur'
          },
            {
              min: 2,
              max: 20,
              message: this.$t('lastNameLengthRequired'),
              trigger: 'blur'
            }
          ],
          Address: [{
            required: true,
            message: this.$t('addressRequired'),
            trigger: 'blur'
          },
            {
              min: 2,
              max: 30,
              message: this.$t('addressNumberLengthRequired'),
              trigger: 'blur'
            }
          ],
          apartment: [{
            required: false,
            message: '',
            trigger: 'blur'
          },
            {
              min: 3,
              max: 10,
              message: this.$t('apartmentNumberLengthRequired'),
              trigger: 'blur'
            }
          ],
          City: [{
            required: true,
            message: this.$t('cityRequired'),
            trigger: 'blur'
          },
            {
              min: 3,
              max: 20,
              message: this.$t('cityLengthRequired'),
              trigger: 'blur'
            }
          ],
          Zip: [{
            required: true,
            message: this.$t('zipCodeRequired'),
            trigger: 'blur'
          },
            {
              min: 3,
              max: 5,
              message: this.$t('zipCodeLengthRequired'),
              trigger: 'blur'
            }
          ],
          Telephone: [{
            required: true,
            message: this.$t('phoneNumberRequired'),
            trigger: 'blur'
          },
            {
              min: 10,
              max: 12,
              message: this.$t('phoneNumberLengthRequired'),
              trigger: 'blur',
            }
          ],
          Country: [{
            required: true,
            message: this.$t('countryRequired'),
            trigger: 'blur'
          },
            {
              min: 3,
              max: 20,
              message: this.$t('countryLengthRequired'),
              trigger: 'blur'
            }
          ],
        }
      }
    }),
    notDefaultAddressList() {
      return this.addresses.filter(item => !item.IsDefault && item.CustomerDetail_id !== this.defaultAddress.CustomerDetail_id)
    }
  },
}
</script>

<style lang="less">
// @import "../../assets/css/profile.less";
@import "../../assets/css/addressNew.less";
@import "../../assets/css/modalNew.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/addressNew.vue